import React from "react";
import { LotteryListPage } from "../../Components/dashboard";

const LotteryList = () => {
  return <LotteryListPage role="admin" />;
};

export default LotteryList;
